import { IndeterminateCheckBox } from './IndeterminateCheckBox';

export default IndeterminateCheckBox;
